var map = {
	"./appstore-dark.svg": "336c",
	"./appstore-white.svg": "28e1",
	"./arrow.svg": "1106",
	"./back.svg": "a11e",
	"./calendar-blue.svg": "b605",
	"./calendar.svg": "4fef",
	"./cancel.svg": "fd77",
	"./card.svg": "e2cf",
	"./check.svg": "6aa8",
	"./checkmark.svg": "83e5",
	"./close.svg": "1d1b",
	"./danger.svg": "e7c1",
	"./documents.svg": "43ad",
	"./eclipse.svg": "94f9",
	"./edit-blue.svg": "3bf4",
	"./edit.svg": "66d5",
	"./fire.svg": "cbb5",
	"./gantel.svg": "a544",
	"./gift.svg": "2e5e",
	"./gp-dark.svg": "c600",
	"./gp-white.svg": "0ca5",
	"./info.svg": "50c1",
	"./kek.svg": "a2a9",
	"./key.svg": "08bd",
	"./kid.svg": "13f7",
	"./left-blue.svg": "7ec4",
	"./left.svg": "0182",
	"./lightning.svg": "8cfa",
	"./loader-registration.svg": "6fcd",
	"./loader.svg": "281f",
	"./location-blue.svg": "5d89",
	"./location.svg": "e496",
	"./login.svg": "4ffb",
	"./logout-blue.svg": "58cf",
	"./logout.svg": "0627",
	"./max.svg": "d161",
	"./money.svg": "7530",
	"./profile.svg": "2efd",
	"./right-blue.svg": "d683",
	"./right.svg": "50d7",
	"./rustore-dark.svg": "15bc",
	"./rustore-white.svg": "ef1f",
	"./sad.svg": "0a12",
	"./search.svg": "6f6b",
	"./setting.svg": "6d1e",
	"./star.svg": "d8e7",
	"./star2.svg": "dabf",
	"./success.svg": "d1ae",
	"./success_reservation_background.svg": "209f",
	"./telegram.svg": "7315",
	"./tick_circle.svg": "84fd",
	"./wallet-blue.svg": "a12e",
	"./wallet.svg": "c2e1",
	"./white-check.svg": "914b",
	"./work_on_fitbase.svg": "a9f1",
	"./work_on_fitbasew.svg": "f813"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";